export default __webpack_public_path__ + "static/media/no-fast.de00fbca.svg";